import {
  ActionValidation,
  ArrayValidation,
  BooleanValidation,
  NumberValidation,
  StringValidation,
} from '../../../../utils/component-validations';
import { fn } from '@ember/helper';
import { reads } from 'macro-decorators';
import { tracked } from '@glimmer/tracking';
import Container from '../../core/container.gjs';
import InputBase from '../../core/input.gjs';
import Super from '../../core/base.gjs';
import styles from './base.module.scss';

export default class SpdsInputLabeledBase extends Super {
  arguments = [
    new ActionValidation({ optional: ['onClick', 'onInput'] }),
    new ArrayValidation({ optional: ['additionalArguments'] }),
    new BooleanValidation({
      optional: ['autofocus', 'checked', 'disabled', 'error', 'indeterminate', 'required'],
    }),
    new NumberValidation({ optional: ['maxLength'] }),
    new StringValidation({
      optional: [
        'ariaLabel',
        'component',
        'groupName',
        'inputClasses',
        'name',
        'placeholder',
        'type',
        'value',
      ],
    }),
  ];
  baseClass = 'spds-input-container spds-input-labeled';
  classesToMapToArgs = ['checked', 'disabled', 'error', 'indeterminate', 'required'];
  styles = styles;

  @tracked inputComponent;

  @reads('args.value') value;

  get inputElement() {
    return this.inputComponent?.baseElement;
  }

  get labelId() {
    return this.composeSubcomponentId('label');
  }

  <template>
    <Container
      @flexWidth={{false}}
      @inputContainer={{true}}
      @tag="label"
      class={{this.classes}}
      data-test-spds-input-label={{this.labelId}}
      id={{this.labelId}}
      for={{this.id}}
      {{this.validateArguments}}
      ...attributes
    >
      <InputBase
        @additionalArguments={{@additionalArguments}}
        @ariaLabel={{@ariaLabel}}
        @autofocus={{@autofocus}}
        @checked={{@checked}}
        @component={{@component}}
        @disabled={{@disabled}}
        @error={{@error}}
        @groupName={{@groupName}}
        @id={{this.id}}
        @indeterminate={{@indeterminate}}
        @maxLength={{@maxLength}}
        @onClick={{@onClick}}
        @onInput={{@onInput}}
        @name={{@name}}
        @placeholder={{@placeholder}}
        @registerComponent={{fn this.registerComponent "inputComponent"}}
        @required={{@required}}
        @type={{@type}}
        @unregisterComponent={{fn this.unregisterComponent "inputComponent"}}
        @value={{@value}}
        class={{@inputClasses}}
      />
      {{yield}}
    </Container>
  </template>
}
